// extracted by mini-css-extract-plugin
export var modal = "_ld-0";